import { baseHelper } from "lib/helpers";
import constant from "lib/constant/constant";

const listData = (cms, user) => {
  return {
    filterData: {
      label: cms("section.orderList.label.filterVendors"),
      filters: [
        {
          key: "vendor",
          label: cms("section.orderList.label.brandName"),
          operatorText: "like",
          type: "text",
        },
      ],
    },
    mainLink: {
      orderNumber: "/order-lake/view/",
      id: "vendorId",
    },
    links: {
      vendor: {
        link: "/providers/view/",
        id: "vendorId",
      },
    },
    productLink: {
      link: "/product-lake/edit/",
      id: "productId",
    },
    sortOptions: [
      { label: cms("section.orderList.label.sortByDateAsc"), value: "createdAt_asc" },
      { label: cms("section.orderList.label.sortByDateDesc"), value: "createdAt_desc" },
      { label: cms("section.orderList.label.sortByOrderIdAsc"), value: "orderNumber_asc" },
      { label: cms("section.orderList.label.sortByOrderIdDesc"), value: "orderNumber_desc" },
    ],
    resourceName: {
      singular: "Order",
      plural: "Orders",
    },

    tabsData: [
      {
        id: "all-orders",
        content: cms("section.orderList.label.all"),
        accessibilityLabel: "All orders",
        panelID: "all-orders-content",
        value: constant.ALL,
      },
      {
        id: "pending",
        content: cms("section.orderList.label.pending"),
        panelID: "pending-content",
        value: constant.PENDING,
      },
      {
        id: "on-hold",
        content: cms("section.orderList.label.onHold"),
        panelID: "on-hold-content",
        value: constant.ONHOLD,
      },
      {
        id: "processing",
        content: cms("section.orderList.label.processing"),
        panelID: "processing-content",
        value: constant.PROCESS,
      },
      {
        id: "completed",
        content: cms("section.orderList.label.completed"),
        panelID: "completed-content",
        value: constant.COMPLETE,
      },
      {
        id: "cancelled",
        content: cms("section.orderList.label.cancelled"),
        panelID: "cancelled-content",
        value: constant.CANCELLED,
      },
      {
        id: "failed",
        content: cms("section.orderList.label.failed"),
        panelID: "failed-content",
        value: constant.FAILED,
      },
      {
        id: "refunded",
        content: cms("section.orderList.label.refunded"),
        panelID: "refunded-content",
        value: constant.REFUND,
      },
      {
        id: "partial",
        content: cms("section.orderList.label.partial"),
        panelID: "partial-content",
        value: constant.PARTIAL,
      },
    ],
    // Note the bigcommerce user status stored in DB is in upper case so we have managed on the basis of ecommerce platform
    filterByStatusOption: [
      {
        label: cms("section.orderList.label.all"),
        value: constant.ALL,
      },
      {
        label: cms("section.orderList.label.completed"),
        value: constant.COMPLETE,
      },
      {
        label: cms("section.orderList.label.processing"),
        value: constant.PROCESS,
      },
      {
        label: cms("section.orderList.label.pending"),
        value: constant.PENDING,
      },
      {
        label: cms("section.orderList.label.onHold"),
        value: "on Hold",
      },
      {
        label: cms("section.orderList.label.cancelled"),
        value: baseHelper.isBigCommerceUser(user) ? "Cancelled" : constant.CANCELLED,
      },
      {
        label: cms("section.orderList.label.failed"),
        value: constant.FAILED,
      },
      {
        label: cms("section.orderList.label.refunded"),
        value: baseHelper.isBigCommerceUser(user) ? "Refunded" : constant.REFUND,
      },
      // {
      //   label: cms("section.orderList.label.partial"),
      //   value: "partial",
      // },
      // {
      //   label: cms("section.orderList.label.awaitingFulfillment"),
      //   value: "Awaiting Fulfillment",
      // },
      {
        label: cms("section.orderList.label.partiallyShipped"),
        value: constant.PARTIALLY_SHIPPED,
      },
      {
        label: cms("section.orderList.label.awaitingPayment"),
        value: constant.AWAITING_PAYMENT,
      },
    ],

    badge: ["status", "fulfillmentStatus"],
    tableData: {
      tbody: [],
    },
  };
};
export default listData;
